import { atom } from 'jotai';

export type MediaGalleryItem =
    | {
          kind?: 'image';
          url: string;
      }
    | {
          kind: 'drawing';
          url: string;
      };

export interface MediaGalleryState {
    medias: MediaGalleryItem[];
    initialIndex: number;
}

export const mediaGalleryDefaultState: MediaGalleryState = {
    medias: [],
    initialIndex: 0,
};

/**
 * State for the media gallery.
 */
export const mediaGalleryAtom = atom<MediaGalleryState>(mediaGalleryDefaultState);
